var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"u-checkbox",class:{ 'u-checkbox_error': _vm.error }},[_vm._t("default"),_c('input',{attrs:{"id":`input-${_vm.uuid}`,"type":"checkbox"},domProps:{"checked":_vm.value},on:{"input":_vm.onInput}}),_c('span',{staticClass:"u-checkbox__checkmark"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }